import LayoutLanding, { fetch } from './LayoutLanding.vue'

export default LayoutLanding
export { fetch }
